import React, { ButtonHTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

const classes = {
  primary: 'bg-primary text-secondary-50',
  'primary-outline': 'border border-primary text-primary-900',
  secondary: 'bg-secondary-50 text-primary-900',
  tertiary: 'bg-secondary text-primary-900',
  danger: 'bg-error text-white',
};

type ButtonProps = {
  variant?: 'primary' | 'secondary' | 'tertiary' | 'primary-outline' | 'danger';
  className?: string;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export default function Button({ variant, className = '', children, ...props }: ButtonProps): JSX.Element {
  return (
    <button
      type="button"
      {...props}
      className={twMerge(
        'flex h-fit w-fit items-center gap-2 whitespace-nowrap rounded-lg px-[16px] py-[8px] font-[600] text-primary transition-all hover:bg-opacity-80 hover:text-opacity-80 disabled:opacity-20 disabled:hover:bg-opacity-100',
        variant ? classes[variant] : undefined,
        className,
      )}>
      {children}
    </button>
  );
}
